import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterArquivoServico, obterArquivoServicoSuccess, obterArquivoServicoFailure, obterArquivoServicoFinish } from "../../actions/Servicos/obter-arquivo-servico-jornal.action";

export interface ObterArquivoServicoState {
    response: EstruturaRetornoDadosOutputDto<string> | null;
    error: string[] | null;
}

export const initialState: ObterArquivoServicoState = {
    response: null,
    error: null,
};

export const ObterArquivoServicoReducer = createReducer(
    initialState,
    on(obterArquivoServico, state => ({ ...state, error: null })),
    on(obterArquivoServicoSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterArquivoServicoFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterArquivoServicoFinish, state => ({ ...state, response: null, error: null }))
);
